import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatIndentIncreaseIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_indent_increase"}/>
}
